export { MappingsStrategy } from './Mappings'
export { DetailedMappingStrategy } from './DetailedMapping'
